module.exports = "<div class=\"aUiModule\">\r\n    <h2>H2 Div_1</h2>\r\n</div>\r\n";